import React, { useImperativeHandle, forwardRef } from 'react'
import { MoveDirections } from 'advanced-cropper/types'
import {
  StencilRef,
  StencilProps,
  StencilWrapper,
  StencilOverlay,
  DraggableArea,
} from 'react-advanced-cropper'
import './circle-stencil.scss'

export const CircleStencil = forwardRef<StencilRef, StencilProps>(
  ({ cropper }: StencilProps, ref) => {
    const coordinates = cropper.getStencilCoordinates()
    const transitions = cropper.getTransitions()

    useImperativeHandle(ref, () => ({
      aspectRatio: 1,
    }))

    const onMove = (directions: MoveDirections) => {
      cropper.moveCoordinates(directions)
    }

    return (
      <StencilWrapper
        className="circle-stencil"
        transitions={transitions}
        {...coordinates}
      >
        <DraggableArea
          className="circle-stencil__draggable-area"
          onMove={onMove}
          onMoveEnd={cropper.moveCoordinatesEnd}
        >
          <StencilOverlay className="circle-stencil__overlay" />
        </DraggableArea>
      </StencilWrapper>
    )
  },
)

CircleStencil.displayName = 'CircleStencil'
